// extracted by mini-css-extract-plugin
export default {"copyListModal":"styles_copy-list-modal__SJ4v0"};